.contentContainer {
  display: flex;
  flex-direction: column;
  padding: 0;
  padding-bottom: 40px;
  gap: 24px;
}

.styledEntityHeader {
  margin: 0;
  padding: 12px 0;
}

.chartWrapper {
  gap: 12px;
}
